import React, { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
} from '@mui/material';

const FieldControlTypeSelector = ({
  isOpen,
  handleClose,
  onSubmit,
  initialControlType = '',
}) => {
  const [controlType, setControlType] = useState(initialControlType);

  const controlTypeValues = {
    '': '',
    'Advance Location Selection': 'AdvancedLocationSearch',
    'AGFMA Site Selector': 'AGFMASiteSearch',
    'AGFMA Facility Selector': 'AGFMAFacilitySearch',
    'Configurable Table Selector': 'TableSearch',
    'Advance Equipment Selection': 'AdvancedEquipmentSearch',
  };

  useEffect(() => {
    setControlType(initialControlType);
  }, 
  [isOpen,
  handleClose,
  onSubmit,
  initialControlType]);

  const handleSave = () => {
    if (onSubmit) onSubmit(controlType);
    handleClose();
  };

  const handleRemove = () => {
    if (onSubmit) onSubmit('');
    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="field-control-type-selector"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
          width: '400px',
          outline: 'none',
        }}
      >
        <h3>Select Control Type</h3>
        <hr />

        <FormControl
          variant="outlined"
          sx={{
            minWidth: '100%',
            mb: 3,
            '& .MuiOutlinedInput-root': {
              // border: controlType === '' ? '1px solid red' : 'inherit',
            },
          }}
        >
          <Select
            name="controlType"
            value={controlType}
            onChange={(e) => setControlType(e.target.value)}
            fullWidth
            sx={{ height: '40px', backgroundColor: 'white' }}
          >
            {Object.keys(controlTypeValues).map((key) => (
              <MenuItem key={key} value={controlTypeValues[key]}>
                {key}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

                        {/* <Select
                          name={key}
                          value={field[key] || ''}
                          onChange={handleInputChange}
                          onBlur={handleMouseOut}
                          disabled={disableControlType}
                          sx={{ height: '40px', backgroundColor: 'white' }}
                        >
                          {Object.keys(controlTypeValues).map((controlTypeKey) => (
                            <MenuItem key={controlTypeKey} value={controlTypeValues[controlTypeKey]}>
                              {controlTypeKey}
                            </MenuItem>
                          ))}
                        </Select> */}

        {/* ACTION BUTTONS */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={!controlType}
            sx={{
              backgroundColor: 'var(--button-color)',
              color: 'white',
              fontWeight: 'normal',
              textTransform: 'none',
              ':hover': { backgroundColor: 'var(--button-hover-color)' },
            }}
          >
            Update
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleRemove}
            sx={{
              backgroundColor: 'var(--button-color-red)',
              color: 'white',
              fontWeight: 'normal',
              textTransform: 'none',
              ':hover': { backgroundColor: 'var(--button-hover-color-red)' },
            }}
          >
            Remove 
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FieldControlTypeSelector;
